import "./styles/globals.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider as JotaiProvider } from "jotai";
import { loadConfig } from "./config/config";
import { initializeI18n } from "./i18n/config";
import { ErrorBoundary, FeedbackToaster } from "@heke/ui-components";
import { ThemeProviderWrapper } from "./styles";
import App from "./App";

await loadConfig();

try {
  await initializeI18n();
} catch (e) {
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML =
      '<p style="padding:2rem;font-family:sans-serif">Translation service unavailable. Please contact support.</p>';
  }
  throw e;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <JotaiProvider>
      <ThemeProviderWrapper>
        <ErrorBoundary>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ErrorBoundary>
        <FeedbackToaster />
      </ThemeProviderWrapper>
    </JotaiProvider>
  </React.StrictMode>,
);
